(function ($) {

    /**
     * Form Data Collector
     */
    var fdcFormHandler = function(e) {
        e.preventDefault();

        var ppForm = $( this ).closest( 'form' );
        var ppFormSubmit = $( this );
        ppFormSubmit.addClass( 'is-loading' );

        // Validate with parsley.js
        ppForm.parsley({
            excluded: '.form-control-hidden',
            successClass: 'is-valid',
            errorClass: 'is-invalid',
            classHandler: function(el) {
                return el.$element;
            }
        })
        .on('form:error', function(e) {
            ppFormSubmit.removeClass( 'is-loading' );
        })
        .on('form:submit', function(e) {

            // Send data to FDC
            fdc.ajax.post(ppForm, {
                error: function(data) {
                    var alert_error = ppForm.data( 'form-error' );
                    $(alert_error).removeClass( 'd-none' );
                },
                success: function(data) {
                    var alert_success = ppForm.data( 'form-success' );
                    $(alert_success).removeClass( 'd-none' );
                    ppForm.find( 'button[data-fdc-action]' ).addClass( 'd-none' );
                }
            });

            return false;
        });
        ppForm.trigger( 'submit' );
    };
    $( '[data-fdc-action="submit"]' ).on( 'click', fdcFormHandler );

})(jQuery);
